import {Component, OnInit} from '@angular/core';
import { MyComplainService } from './my-complain.service';

@Component({
  selector: 'app-regular',
  templateUrl: './my-complains.component.html',
  styles: []
})
export class RegularComponent implements OnInit {

  complains:any;
  
  constructor(private myComplainService : MyComplainService) {
  }


  ngOnInit() {
    this.complains = this.myComplainService.complains
  }

}
